<template>
  <div>
    <el-image
      :src="$domain + 'static/noten/website/newHome/top_banner1.png'"
      alt="编程"
      style="width: 100%;height: 600px;"
    ></el-image>
    <Idea></Idea>
    <Works></Works>
  </div>
</template>

<script>
import Idea from "@/views/creation/components/idea";
import Works from "@/views/creation/components/works";
export default {
  components: { Idea, Works },
  data() {
    return {};
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/views/creation/index.vue